import { render } from "./SeeStats.vue?vue&type=template&id=28ffd647"
import script from "./SeeStats.vue?vue&type=script&lang=js"
export * from "./SeeStats.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__